import React, { Fragment, Component } from 'react';
import Decimal from 'decimal.js';
import PropTypes from 'prop-types';

import { Fee } from 'models/fees';
import { Location } from 'models/locations';

import CurrencySymbol from 'components/common/currency-symbol';
import QuestionMark from 'components/svgs/icons/question-mark';
import FeesBreakdownModal from 'containers/checkout/additional-information/fees-breakdown-modal';

const propTypes = {
  category: PropTypes.string.isRequired,
  fees: PropTypes.arrayOf(PropTypes.instanceOf(Fee)).isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
};

class CheckoutSummaryFeeItem extends Component { 
  constructor(props) {
    super(props);

    this.state = {
      showModal: false
    }

    this.showFeesBreakdown = this.showFeesBreakdown.bind(this);
    this.closeFeesBreakdown = this.closeFeesBreakdown.bind(this);
  }

  get total() {
    const { fees } = this.props;
    let totalPrice = new Decimal(0);
    fees.forEach((fee) => {
      const price = Decimal(fee.price);
      totalPrice = totalPrice.plus(price);
    });
    return totalPrice;
  }

  showFeesBreakdown() {
    this.setState({ showModal: true });
  };

  closeFeesBreakdown() {
    this.setState({ showModal: false });
  };

  renderTotal() {
    const { location } = this.props;
    const { total } = this;
    const prefix = Number(total) < 0 ? '-' : '';

    return (
      <span>
        {prefix}
        <CurrencySymbol location={location} />
        {Math.abs(total).toFixed(2)}
      </span>
    );
  }

  render() {
    const { category, fees, location } = this.props;

    return (
      <Fragment>
        <div className="row margin-top-10">
          <div onClick={this.showFeesBreakdown} className="col-xs-7 col-print-5 col-gutter-right-0 clickable">
            <div className="text-weight-book text-color-dark-slate opacity-50 float-left text-size-sm-16 text-size-xs-14">
              {category}
              <QuestionMark />
            </div>
          </div>
          <div className="text-weight-book text-color-dark-slate opacity-50 col-xs-5 col-print-7 col-gutter-left-0 text-align-right text-size-sm-16 text-size-xs-14">
            {this.renderTotal()}
          </div>
        </div>
        <FeesBreakdownModal
          category={category}
          fees={fees}
          location={location}
          showModal={this.state.showModal}
          closeModal={this.closeFeesBreakdown}
        />
      </Fragment>
    );
  }
}

CheckoutSummaryFeeItem.propTypes = propTypes;

export default CheckoutSummaryFeeItem;
